import View from './View.js';
import previewView from './previewView.js';

class BookmarksView extends View {
  _parentElement = document.querySelector('.bookmarks__list');
  _errorMessage = 'No bookmarks yet.';
  _message = '';

  addHandlerRender(handler) {
    window.addEventListener('load', handler);
  }

  _generateMarkup() {
    return (
      this._data
        // for each of the bookmarks, we need to render a preview.  But this should return a string so it can be inserted into the DOM.
        .map(bookmark => previewView.render(bookmark, false))
        .join('')
    );
  }
}

export default new BookmarksView();
